<template>
	<core-layout-content medium>
		<core-layout-headline-and-actions>
			<template slot="headline">{{ $t("create_product") }}</template>
		</core-layout-headline-and-actions>

		<!-- Language selector -->
		<div class="xs-4 mb4" v-if="$store.state.settings.allowedLocales">
			<div class="pr2 xs-12 fs3 lh125 fw7 pb1">{{ $t("language") }}</div>
			<core-select-locale
				class="xs-12"
				size="xsmall"
				v-model="selectedLocale"
			/>
		</div>

		<!-- Body -->
		<j-card class="xs-12 bg5 r2 p4">
			<!-- Name -->
			<core-form-input
				componentName="j-base-input-text"
				name="name"
				:label="$t('name')"
				v-validate="'required'"
				v-model="form.name"
				:validationErrors="errors"
			/>

			<!-- Plan -->
			<core-form-input
				class="mt6"
				componentName="j-base-input-text"
				name="plan"
				:label="$t('plan')"
				:placeholder="'really_great_product'"
				:description="$t('has_to_be_unique')"
				v-validate="{ required: true, alphanumeric_underscore: true }"
				v-model="form.plan"
				:validationErrors="errors"
			/>

			<!-- Version -->
			<core-form-input
				class="mt6"
				componentName="j-base-input-text"
				name="version"
				:label="$t('version')"
				:placeholder="'1'"
				:description="$t('has_to_be_unique')"
				v-validate="{ required: true, alphanumeric_underscore: true }"
				v-model="form.version"
				:validationErrors="errors"
			/>

			<!-- Type and insurer -->
			<div class="flex wrap xs-12 mt6">
				<div class="xs-12 md-6 md-pr2 mb6 md-mb0">
					<core-form-input
						componentName="core-select-insurance-type"
						name="type"
						:label="$t('type')"
						v-validate="{ required: true }"
						v-model="form.type"
						:validationErrors="errors"
					/>
				</div>
				<div class="xs-12 md-6 md-pl2">
					<core-form-input
						componentName="core-select-insurer"
						name="insurer"
						:label="$t('insurer')"
						v-validate="{ required: true }"
						v-model="form.insurer"
						:validationErrors="errors"
					/>
				</div>
			</div>

			<!-- Buttons -->
			<div class="mt6">
				<j-button :isLoading="isLoading" @click="handleSubmit">{{
					$t("create_product")
				}}</j-button>
			</div>
		</j-card>
	</core-layout-content>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JCard from "@/components/JCard/"
import JButton from "@/components/JButton/"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent.vue"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions.vue"
import CoreSelectLocale from "@/modules/core/components/CoreSelectLocale"

import { i18n } from "@/locales/setup.js"
import api from "../api/"

export default {
	components: {
		CoreFormInput,
		JCard,
		JButton,
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions,
		CoreSelectLocale
	},

	data: () => ({
		isLoading: false,

		selectedLocale: i18n.locale,

		form: {
			name: null,
			type: null,
			insurer: null,
			plan: null,
			version: null
		}
	}),

	methods: {
		async handleSubmit() {
			// Validate form
			const isValid = await this.$validator.validateAll()
			if (!isValid) return

			//---------------------------------------
			// 1: Create Product
			//---------------------------------------
			const { plan, type, version, insurer, name } = this.form
			this.isLoading = true
			const res = await api.createProduct({
				product: {
					productId: {
						plan: plan,
						type: type,
						version: version
					},
					insurerId: insurer
				}
			})
			this.isLoading = false

			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				console.log("error there")
				return
			}

			//---------------------------------------
			// 2: Localize Product - name
			//---------------------------------------
			const id = res.data.createProduct.productId || null
			if (!id) return

			const l10n = {
				locale: this.selectedLocale,
				key: `products-${plan + "|" + version + "|" + type}-name`,
				value: name
			}

			this.isLoading = true
			const res2 = await api.localizeProduct({ l10n })
			this.isLoading = false

			if (res2.errors) {
				this.$store.dispatch("showError", res2.errors)
				return
			}

			// Redirect to product detail of created product
			this.$router.push({
				name: "ProductDetail",
				params: { plan, type, version }
			})
		}
	}
}
</script>
